
import { Button, Modal } from "semantic-ui-react";

type ModEmployeePendingAlertProps = {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

const ModEmployeePendingAlert = (props: ModEmployeePendingAlertProps) => (
    <Modal
      style={{ borderRadius: 0, position: "relative" }}
      open={props.open}
      size="small"
      onClose={props.onCancel}
    >
      <Modal.Header
        style={{
          backgroundColor: "var(--primary-theme-color)",
          borderRadius: 0,
          color: "white",
          padding: "8px 16px",
        }}
      >
        แจ้งเตือน
      </Modal.Header>

      <Modal.Content style={{ fontWeight: "bold", textAlign: "center" }}>
        <p>
          ข้อมูลการศึกษา/ประวัติการทำงานจะถูกบันทึกชั่วคราวและบันทึกจริงหลังจากบันทึกข้อมูลพนักงานแล้ว
        </p>
        <p>คุณต้องการดำเนินการต่อหรือไม่?</p>

        <div style={{ display: "flex", gap: "16px", justifyContent: "center", marginTop: "30px" }}>
          <Button onClick={props.onConfirm}>ดำเนินการต่อ</Button>

          <Button onClick={props.onCancel}>ยกเลิก</Button>
        </div>
      </Modal.Content>
    </Modal>
  );

export default ModEmployeePendingAlert;
